import http from "@/utils/http";
const prefixUrl = {
  detail: "/Index/detailAlerts.html", // API-5
};
export default {
  query(params = {}) {
    return http.get(prefixUrl.detail, { params });
  },
};
